import { Component, Input } from '@angular/core';
import { BtnStyleTypes } from 'libraries/ui_button/btn.component';


/**
 * Btn
 * Generate a button
 * @deprecated use btn instead
 */
@Component({
    selector: 'btnForm',
    templateUrl: 'button.component.html',
    styleUrls: ['../../../../../libraries/ui_button/btn.component.scss']
})
export class ButtonComponent {
    /** Classes to add to element */
    @Input()
    public styleType: BtnStyleTypes;
    @Input()
    public buttonClass: string = '';

    /** Disabled button form if not valid */
    @Input()
    public disabled: boolean = false;

    @Input()
    public index: boolean;

    @Input()
    public title: string;

    /*
     * Type of button. Has to be submit for submitted form
     * Default value : button
     */
    @Input()
    public formType: string = 'button';
}
